import { Controller } from "@hotwired/stimulus"

// Simple file preview controller for media upload forms
export default class extends Controller {
  static targets = ["placeholder", "preview", "image", "video", "filename"]

  connect() {
    this.currentFile = null
  }

  preview(event) {
    const file = event.target.files[0]
    if (!file) {
      this.reset()
      return
    }

    this.currentFile = file
    const objectUrl = URL.createObjectURL(file)
    const isVideo = file.type.startsWith("video/")

    // Hide placeholder
    if (this.hasPlaceholderTarget) {
      this.placeholderTarget.classList.add("hidden")
    }

    // Show preview
    if (this.hasPreviewTarget) {
      this.previewTarget.classList.remove("hidden")
    }

    // Display image or video
    if (isVideo) {
      if (this.hasVideoTarget) {
        this.videoTarget.src = objectUrl
        this.videoTarget.classList.remove("hidden")
      }
      if (this.hasImageTarget) {
        this.imageTarget.classList.add("hidden")
      }
    } else {
      if (this.hasImageTarget) {
        this.imageTarget.src = objectUrl
        this.imageTarget.classList.remove("hidden")
      }
      if (this.hasVideoTarget) {
        this.videoTarget.classList.add("hidden")
      }
    }

    // Show filename
    if (this.hasFilenameTarget) {
      this.filenameTarget.textContent = file.name
    }
  }

  reset() {
    this.currentFile = null

    if (this.hasPlaceholderTarget) {
      this.placeholderTarget.classList.remove("hidden")
    }

    if (this.hasPreviewTarget) {
      this.previewTarget.classList.add("hidden")
    }

    if (this.hasImageTarget) {
      this.imageTarget.src = ""
      this.imageTarget.classList.add("hidden")
    }

    if (this.hasVideoTarget) {
      this.videoTarget.src = ""
      this.videoTarget.classList.add("hidden")
    }

    if (this.hasFilenameTarget) {
      this.filenameTarget.textContent = ""
    }
  }
}

